module.exports = __webpack_public_path__ + "img/ronds.fdabb7fc.png";